module.exports = __webpack_public_path__ + "69bfd7daa0799aaafa5581b4b561dd8f.pdf";